import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../../core/application/store/app.state';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

@Component({
  selector: 'app-organization-information',
  templateUrl: './organization-information.component.html',
  styleUrl: './organization-information.component.scss',
})
export class OrganizationInformationComponent implements OnInit {
  organizationForm!: FormGroup;
  industries: any[] = [];
  industriesLoading = false;
  showIndustryDropdown = false;

  constructor(
    private readonly fb: FormBuilder,
    private readonly store: Store<AppState>,
    private readonly router: Router,
    private readonly http: HttpClient
  ) {
    this.initializeForm();
  }

  ngOnInit(): void {
    // this.loadIndustries();
  }

  private initializeForm(): void {
    this.organizationForm = this.fb.group({
      organizationName: ['', [Validators.required]],
    //   industry: ['', []],
    //   city: ['', [Validators.required]],
    //   state: ['', [Validators.required]],
    //   zipCode: ['', [Validators.required]],
    //   country: ['', [Validators.required]],
    });
  }

  private loadIndustries(): void {
    this.industriesLoading = true;
    this.http.get<any>(`${environment.apiDomain}/v3/companies/industry-values`).subscribe({
      next: res => {
        // Accept common shapes: { data: [...] } or [...] or { industries: [...] }
        const list = res?.data ?? res?.industries ?? res;
        this.industries = Array.isArray(list) ? list : [];
        this.industriesLoading = false;
      },
      error: err => {
        // console.error('Failed to load industries', err);
        this.industries = [];
        this.industriesLoading = false;
      }
    });
  }

  get organizationNameCtrl(): FormControl {
    return this.organizationForm.get('organizationName') as FormControl;
  }

  get cityCtrl(): FormControl {
    return this.organizationForm.get('city') as FormControl;
  }

  get stateCtrl(): FormControl {
    return this.organizationForm.get('state') as FormControl;
  }

  get zipCodeCtrl(): FormControl {
    return this.organizationForm.get('zipCode') as FormControl;
  }

  get countryCtrl(): FormControl {
    return this.organizationForm.get('country') as FormControl;
  }

  back(): void {
    this.router.navigate(['/authentication/register']);
  }

  saveInformation(): void {
    if (this.organizationForm.invalid) return;

    const organizationData = this.organizationForm.value;
    // Store organization information for the next step
    // In the future, this can be replaced with:
    // this.store.dispatch(saveOrganizationInformation({ data: organizationData }));
    localStorage.setItem('pendingOrganizationInfo', JSON.stringify(organizationData));
    this.router.navigate(['/authentication/account-information']);
  }

  toggleIndustryDropdown(): void {
    this.showIndustryDropdown = !this.showIndustryDropdown;
  }

  selectIndustry(value: any): void {
    this.organizationForm.get('industry')?.setValue(value);
    this.showIndustryDropdown = false;
  }

  formatIndustryName(name: string): string {
  if (!name || typeof name !== 'string') return name || '';
  return name
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

getDisplayIndustryName(value: any): string {
  if (!value) return '';

  const industry = this.industries.find(ind => {
    const key = ind?.id ?? ind?.value ?? ind?.name ?? ind;
    return key === value;
  });

  const rawName = industry?.name ?? industry?.label ?? industry?.value ?? industry ?? value;
  return this.formatIndustryName(rawName as string);
}
}
